import { render, staticRenderFns } from "./tab3.vue?vue&type=template&id=c0a6010a&"
import script from "./tab3.vue?vue&type=script&lang=js&"
export * from "./tab3.vue?vue&type=script&lang=js&"
import style0 from "./tab3.vue?vue&type=style&index=0&id=c0a6010a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports